module.exports = __webpack_public_path__ + "media/bootstrap-icons/safe2-fill-9153b27b.svg";